import React from "react";
import Modal from "react-modal";
import { CrossModal } from "./Icon/CrossModal";
import styled from "styled-components";
import Dollar from "./Icon/Dollar";



const ProductModal = ({ isOpen, onClose, product }) => {
    
    const data = product || {
        image: {
            small: "https://cdn.shopify.com/s/files/1/0260/1987/2022/products/1_3_800x.jpg?v=1670529054",
        },
        brand: "Brand Name",
        name: "Product Name",
        date_launched: "2023-10-01",
        categories:[{name:''}],
        attributes:[{name:'',id:0,type : ''}],
        skus: [{id: "",
          size: "",
          unit: "",
          price: "",
          currency: ""}]
        ,
        ingredients:'',
        descripiton:'',

    };
    

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                overlay: {  
                    backdropFilter: "blur(5px)", 
                    zIndex:1000,
                    backgroundColor: "rgba(255, 255, 255, 0.4)" 
                }
                    ,
                content: {
                    
                    top:'10%',
                    width: "60%",
                    height: "90%",
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap:'90px',
                    background:'transparent',
                    border: "none",
                    
                    
                }
            }}
        >
            {/* Close Button */}
            <div style={{display:'flex',justifyContent:'flex-end',}}>
            <button 
                onClick={onClose} 
                style={{
                    position: "absolute", 
                    width:56,
                    background:"rgba(255, 255, 255, 1)",
                    borderRadius:'64px',
                    height:56,
                    
                    border: "none", 
                    // padding: "5px 10px",
                    cursor: "pointer",
                    

                }}
            >
                <CrossModal/>
            </button>
            </div>
            

            
            <div style={{
                padding: "32px",
                
                display:'flex',
                
                border: "none",
                borderRadius: "32px",
                boxShadow:' 0px 0px 40px 0.66px rgba(0, 0, 0, 0.06)',
                height:'80%',
                background: "rgba(255, 255, 255, 1)",
            }}>
                <div style={{display:'flex',flexDirection:'row',gap:32}}>
                    <ImgWrapper>
                    <Img src={data.image.large}>
                    </Img>
                    </ImgWrapper>
                    <ProductInfo>
                        <P1>
                            <P1Txt>Brand <span style={{color:'rgba(47, 50, 55, 1)'}}>{data.brand}</span></P1Txt>
                            <P1Txt2>{data.name}</P1Txt2>
                        </P1>
                        
                          {data?.date_launched && !data.date_launched.includes('1970-01-01') && (
  <P1Txt>
    Date Launched{" "}
    <span style={{ color: 'rgba(32, 35, 39, 1)' }}>
      {data.date_launched}
    </span>
  </P1Txt>
)}
                        
                        <div style={{ display: 'flex',alignItems:'center' ,flexDirection: 'row', flexWrap: 'wrap' }}>
  {data.categories.map((category, index) => (
    <span key={index}>
      <P1Txt style={{ color: 'rgba(47, 50, 55, 1)' }}>
        {category.name}
        
          <span style={{ color: 'rgba(217, 217, 217, 1)', margin: '0 5px' }}>|</span>
          
      </P1Txt>
      
       
    </span> 
  ))}
    {[...Array(Number(data.priceRange || 0))].map((_, index) => (
            <Dollar key={index} color={index === 0 ? 'rgba(32, 35, 39, 1)' : 'rgba(32, 35, 39, 0.6)'}/>
          ))}
</div> 
<P2>
                         {data.skus.map((sku,index)=> <P21>
                          <P2Txt>${sku.price}</P2Txt> 
                          <P2Txt2>/{sku.size}{sku.unit}</P2Txt2>
                        </P21>)}
                         
                        
                        </P2>
                        <P1>
                            <P1Txt>Description</P1Txt>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
  <P1Txt style={{ color: 'rgba(47, 50, 55, 1)' }}>
    {data.description}
    
  </P1Txt>
</div>
                        </P1>
                         <P1>
                            <P1Txt>Brand Description</P1Txt>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
  <P1Txt style={{ color: 'rgba(47, 50, 55, 1)' }}>
    {data.brand_desc}
    
  </P1Txt>
</div>
                        </P1>
                       
                        <P1>
                            <P1Txt>Attributes</P1Txt>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
  <P1Txt style={{ color: 'rgba(47, 50, 55, 1)' }}>
    {data.attributes
  .filter(attr => attr.type !== 'Internal')
  .map((attribute, index, arr) => (
    <span key={index}>
      {attribute.name}
      {index < arr.length - 1 && ', '}
    </span>
  ))}
  </P1Txt>
</div>
                        </P1>
                        
                        <P1 >
                            <P1Txt>Ingredient list</P1Txt>
                            <P1Txt style={{color:'rgba(32, 35, 39, 1)'}}>{data.ingredients}</P1Txt>
                        </P1>
                        
                    </ProductInfo>
                </div>

            </div>
        </Modal>
    );
};

export default ProductModal;
const ImgWrapper = styled.div`
width: 40%;
height: 100%;
display: flex;
align-items: center;
gap: 20.87px;
border-radius: 32px;
padding: 6px;
// background: rgba(249, 249, 249, 1);
`

const Img = styled.img`
// border-radius: 32px;
width: 97%;
height: 97%;
 max-width: 400px;
 background: rgba(249, 249, 249, 1);
  max-height: 400px;
object-fit: cover;
`

const ProductInfo = styled.div`
width: 50%;
height: 100%;
display: flex;
overflow:scroll;

flex-direction:column;

gap:24px;

`

const P1= styled.div`
display: flex;
flex-direction:column;
gap:8px;
height:100%;

`
const P1Txt = styled.p`

font-weight: 500;
font-size: 14px;
line-height: 120%;
letter-spacing: 0%;
margin:0;
color:rgba(47, 50, 55, 0.6)

`
const P1Txt2 = styled.p`
margin:0;
font-weight: 600;
font-size: 32px;
line-height: 110.00000000000001%;
letter-spacing: -1%;
color:rgba(32, 35, 39, 1);
`
const P2 = styled.div
`
display: flex;

flex-direction:row;
// justify-content: space-between; 
`
const P21 = styled.div
`
display: flex;
width:100%;

flex-direction:row;
gap:10px;


align-items:end;


`
const P2Txt = styled.p`
margin:0;
font-weight: 700;
font-size: 28px;

line-height: 18px;
text-align:flex-end; 
letter-spacing: -1%;
color:rgba(32, 35, 39, 1);
`
const P2Txt2 = styled.p`
  margin: 0;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  letter-spacing: -1%;
  color: rgba(32, 35, 39, 1);
  display: flex;
  align-items: baseline; /* aligns text on same line visually */
`;